module.exports = __webpack_public_path__ + "img/13.dae1f5f3.jpg";